import styled from "@emotion/styled";

export const Title = styled.div({
    marginLeft: 10,
    marginBottom: 5,
});

export const Body = styled.div({
    marginLeft: 29,
    marginBottom: 15,
});
